import { v4 as uuid } from 'uuid';
import {
  BLOCK,
  OPTION_SELECT,
  TEXT,
  RATING,
  RATING_NUMBER,
  RATING_STAR,
  BLOCK_MODES,
} from 'lib/block';

const [SINGLE] = BLOCK_MODES[OPTION_SELECT];
const [HORIZONTAL] = BLOCK_MODES[RATING_NUMBER];

const ratingStarTemplate = ({ blockId, elementId }) => ({
  type: BLOCK,
  blockType: RATING,
  id: blockId,
  content: {
    type: OPTION_SELECT,
    ratingType: RATING_STAR,
    id: elementId,
    leadingFill: true,
    label: {
      type: TEXT,
      id: uuid(),
      text: 'Question label',
      style: {
        fontName: 'System Default Regular',
        foregroundColor: { light: '#000000' },
        marginBottom: 12,
        horizontalAlignment: 'leading',
        textAlignment: 'leading',
      },
    },
    selectMode: SINGLE,
    options: [
      {
        value: '1',
        content: {
          id: uuid(),
          type: TEXT,
          text: '☆',
          style: {
            fontName: 'System Default Regular',
            fontSize: 36,
            foregroundColor: {
              light: '#627293',
            },
            height: 48,
            marginBottom: 8,
            marginLeading: 4,
            marginTrailing: 4,
            width: 48,
          },
        },
        selectedContent: {
          id: uuid(),
          type: TEXT,
          text: '★',
          style: {
            fontName: 'System Default Regular',
            fontSize: 36,
            foregroundColor: {
              light: '#000000',
            },
            height: 48,
            marginBottom: 8,
            marginLeading: 4,
            marginTrailing: 4,
            width: 48,
          },
        },
      },
      {
        value: '2',
        content: {
          id: uuid(),
          type: TEXT,
          text: '☆',
          style: {
            fontName: 'System Default Regular',
            fontSize: 36,
            foregroundColor: {
              light: '#627293',
            },
            height: 48,
            marginBottom: 8,
            marginLeading: 4,
            marginTrailing: 4,
            width: 48,
          },
        },
        selectedContent: {
          id: uuid(),
          type: TEXT,
          text: '★',
          style: {
            fontName: 'System Default Regular',
            fontSize: 36,
            foregroundColor: {
              light: '#000000',
            },
            height: 48,
            marginBottom: 8,
            marginLeading: 4,
            marginTrailing: 4,
            width: 48,
          },
        },
      },
      {
        value: '3',
        content: {
          id: uuid(),
          type: TEXT,
          text: '☆',
          style: {
            fontName: 'System Default Regular',
            fontSize: 36,
            foregroundColor: {
              light: '#627293',
            },
            height: 48,
            marginBottom: 8,
            marginLeading: 4,
            marginTrailing: 4,
            width: 48,
          },
        },
        selectedContent: {
          id: uuid(),
          type: TEXT,
          text: '★',
          style: {
            fontName: 'System Default Regular',
            fontSize: 36,
            foregroundColor: {
              light: '#000000',
            },
            height: 48,
            marginBottom: 8,
            marginLeading: 4,
            marginTrailing: 4,
            width: 48,
          },
        },
      },
      {
        value: '4',
        content: {
          id: uuid(),
          type: TEXT,
          text: '☆',
          style: {
            fontName: 'System Default Regular',
            fontSize: 36,
            foregroundColor: {
              light: '#627293',
            },
            height: 48,
            marginBottom: 8,
            marginLeading: 4,
            marginTrailing: 4,
            width: 48,
          },
        },
        selectedContent: {
          id: uuid(),
          type: TEXT,
          text: '★',
          style: {
            fontName: 'System Default Regular',
            fontSize: 36,
            foregroundColor: {
              light: '#000000',
            },
            height: 48,
            marginBottom: 8,
            marginLeading: 4,
            marginTrailing: 4,
            width: 48,
          },
        },
      },
      {
        value: '5',
        content: {
          id: uuid(),
          type: TEXT,
          text: '☆',
          style: {
            fontName: 'System Default Regular',
            fontSize: 36,
            foregroundColor: {
              light: '#627293',
            },
            height: 48,
            marginBottom: 8,
            marginLeading: 4,
            marginTrailing: 4,
            width: 48,
          },
        },
        selectedContent: {
          id: uuid(),
          type: TEXT,
          text: '★',
          style: {
            fontName: 'System Default Regular',
            fontSize: 36,
            foregroundColor: {
              light: '#000000',
            },
            height: 48,
            marginBottom: 8,
            marginLeading: 4,
            marginTrailing: 4,
            width: 48,
          },
        },
      },
    ],
    controlPosition: 'hidden',
    displayFormat: HORIZONTAL,
    style: {
      horizontalAlignment: 'center',
      marginTop: 12,
      marginBottom: 12,
      marginLeading: 12,
      marginTrailing: 12,
      width: -1,
    },
    errorLabel: {
      type: TEXT,
      id: uuid(),
      text: 'Required field',
      style: {
        foregroundColor: { light: '#D6216B' },
        horizontalAlignment: 'leading',
        textAlignment: 'leading',
        fontSize: 14,
        marginTop: 10,
      },
    },
  },
});

export default ratingStarTemplate;
